// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";

import { useMemo } from "@mairistem/tools";

import { DraftService } from "../services";

import { DataProvider } from "../../libs/components/DataProvider";

export const DraftDataProvider = (props) => {
	const { children, domain } = props;

	const [drafts, loading, fetching] = DraftService.queryDraftsByDomain(domain);

	return useMemo(
		() => (
			<DataProvider data={drafts} loading={loading} fetching={fetching}>
				{children}
			</DataProvider>
		),
		[children, loading, fetching, drafts],
	);
};
